<template>
	<div class="w-full">
		<div v-if="!isLoading">
			<div v-if="goals.length">
				<div>
					<div class="mb-10">
						<div class="shadow-sm sm:rounded-2xl">
							<div class="__record__table scroll-bar">
								<div class="sm:rounded-t-2xl w-fit min-w-full">
									<table
										class="
											min-w-full
											divide-y
											text-neutral-200
											rounded-2xl
										"
									>
										<thead
											class="
												bg-neutral-100
												h-16
												rounded-2xl
											"
										>
											<tr>
												<th
													scope="col"
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														w-16
														whitespace-nowrap
													"
												>
													STT
												</th>
												<th
													scope="col"
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
												>
													tên thư viện
												</th>
												<th
													scope="col"
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
												>
													mục tiêu
												</th>
												<th
													scope="col"
													class="
														px-6
														py-3
														text-left text-xs
														font-semibold
														text-neutral-600
														uppercase
														tracking-wider
														whitespace-nowrap
													"
												>
													lĩnh vực
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(goal, i) in goals"
												:key="goal.id"
												:class="
													i % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												"
												class="
													text-neutral-700
													cursor-pointer
													hover:bg-orange-50
												"
												@click="
													$router.push({
														name: ROUTER_NAME.CREATE_FORM_EVALUATION_BY_LIB_GOALS,
														params: {
															...$route.params,
															lId: goal.id,
														},
													})
												"
											>
												<td
													class="
														px-6
														py-4
														whitespace-nowrap
														text-neutral-700
														text-center
													"
												>
													{{ i + 1 }}
												</td>
												<td
													class="
														px-6
														py-4
														text-neutral-700
													"
													style="width: 300px"
												>
													<div
														class="
															flex
															items-center
															gap-2
															justify-start
														"
													>
														<div class="w-4">
															<svg
																width="16"
																height="16"
																viewBox="0 0 16 16"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	fill-rule="evenodd"
																	clip-rule="evenodd"
																	d="M14.4115 5.52987C14.3596 5.06269 14.3596 4.28406 14.7749 4.02452C14.7749 4.02452 14.7749 4.02452 14.8268 4.02452C15.1383 3.9207 15.3978 3.76497 15.1902 3.55734L10.1031 2.00008L1.84963 3.14207C1.84963 3.14207 0.91527 3.29779 0.967178 4.75124C1.01909 5.52987 1.27863 5.94514 1.48627 6.15277L0.811452 6.36041C0.655726 6.56804 0.863361 6.72377 1.22672 6.82758C1.64199 7.08713 1.64199 7.86576 1.59008 8.33294C0.0847304 8.74821 0.603817 8.90393 0.603817 8.90393L0.967178 9.00775C0.707635 9.21538 0.5 9.63065 0.5 10.3574C0.603817 11.8627 1.38245 11.9146 1.38245 11.9146L6.78095 13.6795L14.9306 11.707C14.9306 11.707 15.5016 11.6032 13.9963 11.136C13.8924 10.6688 13.8924 9.8902 14.3077 9.63065C14.3596 9.63065 14.3596 9.63065 14.3596 9.63065C14.6711 9.52684 14.9306 9.37111 14.723 9.16348L14.4115 9.05966C14.6192 8.90393 14.9825 8.54057 15.0344 7.55431C15.0863 6.87949 14.8787 6.51613 14.723 6.25659L15.3978 6.10086C15.3978 6.10086 15.9688 5.94514 14.4115 5.52987ZM7.61149 5.52987L8.96112 5.21842L13.6329 4.28406L14.3077 4.12833C14.1001 4.5436 14.1001 5.1146 14.152 5.42605C14.152 5.52987 14.152 5.58178 14.152 5.68559L13.4253 5.84132L7.55958 7.29476L7.61149 5.52987ZM1.6939 6.9314L2.42062 7.08713L6.83286 8.02148L7.24813 8.07339L8.39012 8.33294L8.49394 10.0978L2.47253 8.59248L1.84963 8.48866C1.84963 8.43675 1.90153 8.33294 1.90153 8.28103C1.90153 7.91767 1.95344 7.34667 1.6939 6.9314ZM1.43436 4.69933C1.43436 4.28406 1.48627 4.02452 1.64199 3.86879C1.74581 3.76497 1.84963 3.76497 1.90153 3.76497C1.95344 3.76497 2.00535 3.76497 2.00535 3.76497L5.53514 4.90696L7.30004 5.47796L7.24813 7.29476L2.2649 5.89323L2.00535 5.84132C1.95344 5.84132 1.48627 5.78941 1.43436 4.69933ZM6.78095 12.9009L1.53817 11.4475C1.48627 11.4475 1.01909 11.3955 0.967178 10.3055C0.967178 9.8902 1.071 9.63065 1.17481 9.47493C1.27863 9.37111 1.38245 9.37111 1.43436 9.37111C1.48627 9.37111 1.53817 9.37111 1.53817 9.37111L6.88477 11.136L6.78095 12.9009ZM13.6848 11.0841C13.6848 11.136 13.6848 11.2398 13.6848 11.2917L7.0924 12.9009L7.14431 11.136L8.54585 10.8246L8.75348 10.8765L9.53211 10.6169L13.1657 9.8902L13.8405 9.73447C13.6329 10.1497 13.6329 10.7207 13.6848 11.0841ZM14.0482 8.64439H13.9963L13.5291 8.80011L8.75348 10.0978L8.70157 8.33294L10.2588 7.81385L14.0482 6.56804C14.0482 6.56804 14.2039 6.51613 14.3596 6.67186C14.5153 6.82758 14.5673 7.08713 14.5673 7.5024C14.5673 8.59248 14.0482 8.64439 14.0482 8.64439Z"
																	fill="#94A3B8"
																/>
															</svg>
														</div>
														<div
															v-html="goal?.name"
														></div>
													</div>
												</td>
												<td
													class="
														px-6
														py-4
														text-neutral-700
													"
													style="width: 250px"
												>
													{{
														goal?.numbers_of_goal ||
														'-'
													}}
												</td>
												<td
													class="
														px-6
														py-4
														text-neutral-700
													"
													style="width: 250px"
												>
													{{
														goal?.numbers_of_skill ||
														'-'
													}}
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				v-else
				class="w-full h-full flex items-center justify-center flex-col"
			>
				<img
					src="@/assets/images/illustrations/not_found.png"
					alt=""
					height="250"
					width="250"
				/>
				<div
					class="text-neutral-400 text-lg text-center"
					style="max-width: 900px"
				>
					Trung tâm chưa có thư viện nội bộ nào.
				</div>
				<div class="mt-8" v-if="isAdmin">
					<button
						type="button"
						class="
							button-p
							text-center
							shadow-none
							flex
							items-center
							justify-center
							w-fit
							px-6
							bg-none
							btn--ghost
						"
						@click="$router.push('/goal-lib')"
					>
						Tạo mới
					</button>
				</div>
			</div>
		</div>
		<div v-else><Loading /></div>
	</div>
</template>

<script>
import { $api } from '@/services';
import Loading from '@/components/common/Loading';
import { _ROUTER_NAME } from '@/enums';

export default {
	name: 'CreateGoalByLib',
	components: { Loading },
	data() {
		return {
			ROUTER_NAME: _ROUTER_NAME,
			isLoading: true,
			goals: [],
		};
	},

	created() {
		this.fetchAllGoalLib();
	},

	computed: {
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
	},

	methods: {
		async fetchAllGoalLib() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchAllGoalLib({}, this.isAdmin);
				this.goals = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.isLoading = false;
			}
		},
	},
};
</script>
